/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Button } from "reactstrap";

// core components

function IndexHeader() {
  return (
    <>
        <div
            className="page-header section-dark"
            style={{
                backgroundImage:
                "url(" + require("assets/img/BG.png") + ")",
            }}
        >
            <div className="filter" />
            <div className="content-center">
                <Container>
                    <div className="title-brand">
                        <h1 className="presentation-title">OutReach 150</h1>
                    </div>
                    <h2 className="presentation-subtitle text-center">
                        by IET MBCET
                    </h2>
                </Container>
            </div>
            <h6 className="category category-absolute">
                <img
                    alt="MBCET"
                    className="creative-tim-logo"
                    src={require("assets/img/mbcet_logo.png")}
                    style={{"margin": "0px 10px"}}
                />
                <img
                    alt="IET"
                    className="creative-tim-logo"
                    src={require("assets/img/vydyuthi_logo.png")}
                    style={{"margin": "0px 10px", "filter": "brightness(1000%) contrast(100%)"}}
                />
                <img
                    alt="IET"
                    className="creative-tim-logo"
                    src={require("assets/img/logo.png")}
                    style={{"padding": "0px 20px", "filter": "grayscale(1000%) contrast(100%)"}}
                />
            </h6>
        </div>
    </>
  );
}

export default IndexHeader;
